import React from "react"

import { AnalyticsContext } from "./AnalyticsProvider"

export const useAnalytics = () => {
  const analytics = React.useContext(AnalyticsContext)
  if (!analytics) throw new Error("Provider must be added to the top")
  return analytics
}
